/**
 * Servicio para crear campañas SB Single Keyword
 * Cada keyword genera una campaña independiente
 */

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

const SbSingleKeywordCampaignAPI = {

    /**
     * Sube archivos CSV, logo y creative
     */
    uploadFiles: async function (keywordsCSV, productsCSV, logo, creative, negativeCSV) {
        const formData = new FormData();

        if (keywordsCSV) formData.append('keywordsCSV', keywordsCSV);
        if (productsCSV) formData.append('productsCSV', productsCSV);
        if (logo) formData.append('logo', logo);
        if (creative) formData.append('creative', creative);
        if (negativeCSV) formData.append('negativeCSV', negativeCSV);

        const response = await fetch(`${API_BASE_URL}/sb-single-keyword/upload`, {
            method: 'POST',
            body: formData
        });

        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.error || 'Error al subir archivos');
        }

        return await response.json();
    },

    /**
     * Crea una campaña SB single keyword
     */
    createCampaign: async function (options) {
        const formData = new FormData();

        formData.append('profileId', options.profileId);
        formData.append('campaignName', options.campaignName);
        formData.append('dailyBudget', options.dailyBudget);
        formData.append('headline', options.headline);
        formData.append('startDate', options.startDate);
        formData.append('endDate', options.endDate);
        formData.append('defaultBid', options.defaultBid);
        formData.append('state', options.state);
        formData.append('brandEntityId', options.brandEntityId);
        formData.append('adFormat', options.adFormat || 'productCollection');

        // Append JSON strings
        formData.append('keywords', JSON.stringify(options.keywords));
        formData.append('productAsins', JSON.stringify(options.productAsins));

        // Append files if provided
        if (options.logo) formData.append('logo', options.logo);
        if (options.creative) formData.append('creative', options.creative);

        const response = await fetch(`${API_BASE_URL}/sb-single-keyword/create`, {
            method: 'POST',
            body: formData
        });

        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.error || 'Error al crear campaña');
        }

        return await response.json();
    },

    /**
     * Obtiene marcas disponibles
     */
    getBrands: async function (profileId) {
        const response = await fetch(`${API_BASE_URL}/sb-single-keyword/brands?profileId=${profileId}`);
        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.error || 'Error al obtener marcas');
        }
        return await response.json();
    }
};

export default SbSingleKeywordCampaignAPI;
